import { IssuePermittedAction, IssueStatus } from "./Issue";

export enum CurrentUserPermissionLevel {
  Read = "read",
  Write = "write",
  Create = "create",
}

export interface CurrentUserPermissions {
  id: string;
  isProjectAdmin: boolean;
  allTypes?: boolean;
  canManageTemplates: boolean;
  issues: {
    filter: {
      permittedStatuses: IssueStatus[];
    };
    new: {
      permittedStatuses: IssueStatus[];
      permittedActions: IssuePermittedAction[];
      permittedAttributes: string[];
      permittedTypes?: string[];
    };
  };
  permissionLevels: CurrentUserPermissionLevel[];
}
